import Login from "../containers/venderFlow/login";
import ForgotPassword from "../containers/venderFlow/forgotpassword";
import MobileLogin from "../containers/venderFlow/mobileLogin";
import Registration from "../containers/venderFlow/registration";
import ResetPassword from "../containers/venderFlow/resetpassword";
import VerifyOtp from "../containers/venderFlow/verifyotp";
import { PATH } from "./path";
import VerifyEmail from "../containers/venderFlow/verifyEmail/Index";
import ProfileSetup from "../containers/venderFlow/profileSetup";
import ProfilePreview from "../containers/venderFlow/ProfilePreview";
import vendorDashboard from "../containers/venderFlow/dashboard";

export const publicRouteNavigators = [
    {
        name: "login",
        path: PATH.LOGIN,
        PropComponent: Login,
    },
    {
        name: "forgotPassword",
        path: PATH.FORGOTPASSWORD,
        PropComponent: ForgotPassword,
    },
    {
        name: "mobileLogin",
        path: PATH.MOBILELOGIN,
        PropComponent: MobileLogin,
    },
    {
        name: "registration",
        path: PATH.REGISTRATION,
        PropComponent: Registration,
    },
    {
        name: "reset-password",
        path: PATH.RESETPASSWORD,
        PropComponent: ResetPassword,
    },
    {
        name: "verifyOtp",
        path: PATH.VERIFYOTP,
        PropComponent: VerifyOtp,
    },
    {
        name: "verifyEmail",
        path: PATH.VERIFYEMAIL,
        PropComponent: VerifyEmail,
    },
    
];

export const protectedRouteNavigators = [
    {
        name: "profileSetup",
        path: PATH.PROFILESETUP,
        PropComponent: ProfileSetup,
    },
    {
        name: "profilePreview",
        path: PATH.PROFILEPREVIEW,
        PropComponent: ProfilePreview,
    },
    {
        name: "vendorDashboard",
        path: PATH.VENDORDASHBOARD,
        PropComponent: vendorDashboard,
    },
    
];